import {XMarkIcon} from "@heroicons/react/20/solid";
import React from "react";

export const RemoveButton = ({onClick}: { onClick: any }) => {
    return (
        <button
            onClick={onClick}
            type="button"
            className="bg-transparent border-solid border rounded transition duration-200 text-red-400 shadow-sm hover:bg-red-100 flex justify-center items-center h-8 w-8"
        >
            <XMarkIcon aria-hidden="true" className="size-5"/>
        </button>
    )
}
